<div class="dropdown" [class.is-active]="isOpen">
  <div class="dropdown-trigger">
    <button
      [attr.aria-expanded]="isOpen"
      class="button is-chip is-size-7-mobile"
      [class.is-applied]="getValues().length"
      [disabled]="disabled"
      [class.is-active]="isOpen"
      (click)="itemToggled.emit()"
      type="button"
      title="Type"
      i18n-title
    >
      <span>
        <span i18n>Type</span>
        <span *ngIf="localPreSelectedEntities.size" data-e2e="amount-selected-entities">
          (+{{ localPreSelectedEntities.size }})
        </span>
      </span>
      <span class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>

  <div class="dropdown-menu is-large">
    <div class="dropdown-content">
      <div class="dropdown-item is-scrollable">
        <ng-container *ngFor="let entityType of entityTypeList">
          <portal-search-filter-radio
            [id]="entityType.id"
            [text]="entityType.text"
            radioName="entityType"
            [selectedEntities]="localPreSelectedEntities"
            (selected)="onEntityTypeSelection(entityType)"
            [refresh$]="refresh$"
          >
          </portal-search-filter-radio>
        </ng-container>
      </div>

      <div class="dropdown-item is-flex is-justify-content-space-between">
        <button
          class="button is-outlined"
          data-e2e="button-clear-filter"
          i18n
          (click)="removeAllEntities()"
          type="button"
          title="Clear"
          i18n-title
        >
          Clear
        </button>
        <button
          class="button is-primary"
          data-e2e="button-apply-filter"
          i18n
          (click)="onFilterApplied()"
          type="button"
          title="Apply"
          i18n-title
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
